import http from 'axios';

import serializeParams from 'lib/utils/url';

import {
  getBrowserInfo,
  getTimezone
} from 'services/helpers/browser';

import logrocket from '@/services/logrocket';
import { API_URL } from '@/.env';

http.interceptors.response.use((response) => {
  return response;
}, function(error) {
  return Promise.reject(error.response);
});

export default {
  getProject(projectName) {
    return http.get(`${API_URL}project/${projectName}`).then(response => {
      console.log('project', response.data.project_id, response.data);
      logrocket.identify(response.data.project_id, {
        ...response.data,
      });

      return response;
    });
  },
  getCommission(projectName, amount) {
    return http.get(`${API_URL}project/${projectName}/commission/${amount}`).then(response => {
      console.log('project/commission', projectName, { projectName, amount });
      logrocket.identify(projectName, { projectName, amount });

      return response;
    });
  },
  getBill(code) {
    return http.get(`${API_URL}project/bill/${code}`).then(response => {
      console.log('project/bill', code, response.data);
      logrocket.identify(code, {
        ...response.data,
      });

      return response;
    });
  },
  getTildaInfo(orderId, projectCode) {
    return http.get(`${API_URL}project/tilda?orderId=${orderId}&projectCode=${projectCode}`).then(response => {
      console.log('project/tilda', projectCode, response.data);
      logrocket.identify(projectCode, {
        ...response.data,
        projectCode,
        orderId,
      });

      return response;
    });
  },
  fetchMarketplaceBills(payload) {
    return http.get(`${API_URL}project/marketplace/bills?${payload}`);
  },
  getProjectAnalytics(projectCode) {
    return http.get(`${API_URL}project/${projectCode}/analytics`);
  },

  // POST /v1/pp/payment
  createPayment(data) {
    return http.post(`${API_URL}payment`, {
      ...data,
      timezone: getTimezone(),
    }).then(response => {
      console.log('payment/create', data.projectId, data);
      logrocket.identify(data.projectId, {
        ...data,
      });

      return response;
    });
  },

  // POST /v1/pp/crypto/payment
  createCryptoPayment(data) {
    return http.post(`${API_URL}crypto/payment`, {
      ...data,
      timezone: getTimezone(),
    }).then(response => {
      console.log('crypto/payment/create', data.projectId, data);
      logrocket.identify(data.projectId, {
        ...data,
      });

      return response;
    });
  },

  // GET /v1/pp/payment?id=&processToken=
  getPaymentStatus(paymentId, processToken) {
    return http.get(`${API_URL}payment?id=${paymentId}&processToken=${processToken}`)
      .then(response => {
        console.log('payment/status', paymentId, response.data);
        logrocket.identify(paymentId, {
          ...response.data,
        });

        return response;
      });
  },

  // GET /v1/pp/crypto/payment?id=&processToken=
  getCryptoPaymentStatus(paymentId, processToken) {
    return http.get(`${API_URL}crypto/payment?id=${paymentId}&processToken=${processToken}`)
      .then(response => {
        console.log('crypto/payment/status', paymentId, response.data);
        logrocket.identify(paymentId, {
          ...response.data,
        });

        return response;
      });
  },

  cardSale(data) {
    return http.post(`${API_URL}card/sale`, {
      ...data,
      browserInfo: getBrowserInfo(),
    }).then(response => {
      console.log('card/sale', data.paymentId, data);

      const cardPan = data.cardData.pan.replace(/\s*/g, '');
      const formattedCardPan = `${cardPan.slice(0, 6)}****${cardPan.slice(-4)}`;

      logrocket.identify(data.paymentId, {
        ...data,
        cardData: {
          ...data.cardData,
          pan: formattedCardPan,
        },
      });

      return response;
    });
  },

  checkoutSale(data) {
    console.log('checkout/sale', {
      ...data,
      browserInfo: getBrowserInfo(),
    });
    return http.post(`${API_URL}checkout/sale`, {
      ...data,
      browserInfo: getBrowserInfo(),
    });
  },

  getBankName(bin) {
    return http.get(`${API_URL}card/bin/${bin}`).then(response => {
      console.log('card/bin', bin);
      logrocket.identify(bin, {
        ...response.data,
      });

      return response;
    });
  },

  sendReceipt(data) {
    return http.post(`${API_URL}receipt`, data).then(response => {
      console.log('receipt', data.email, data);
      logrocket.identify(data.email, {
        ...data,
      });

      return response;
    });
  },

  sendDigitalSellingReceipt(data) {
    return http.post(`${API_URL}content/receipt`, data).then(response => {
      console.log('content/receipt', data.paymentId, data);
      logrocket.identify(data.paymentId, {
        ...data,
      });

      return response;
    });
  },

  getDigitalContentAccess(body) {
    return http.post(`${API_URL}content/access`, body).then(response => {
      console.log('content/access', response.data.externalDigitalContentCode, response.data);
      logrocket.identify(response.data.externalDigitalContentCode, {
        ...response.data,
      });

      return response;
    });
  },

  getContentBill(paymentId) {
    return http.get(`${API_URL}content/bill/${paymentId}`).then(response => {
      console.log('content/bill', paymentId, response.data);
      logrocket.identify(paymentId, {
        ...response.data,
      });

      return response;
    });
  },

  fetchSubscription(paymentId, accessToken) {
    return http.get(`${API_URL}subscription/?paymentId=${paymentId}&token=${accessToken}`);
  },
  subscriptionAccess(body) {
    return http.post(`${API_URL}subscription/access`, body).then(response => {
      console.log('subscription/access', body.paymentId, body);
      logrocket.identify(body.paymentId, {
        ...body,
      });

      return response;
    });
  },
  subscriptionCancel(paymentId) {
    return http.post(`${API_URL}subscription/cancel/${paymentId}`).then(response => {
      console.log('subscription/cancel', paymentId);
      logrocket.identify(paymentId, {});

      return response;
    });
  },

  getAmountWithDiscount(payload) {
    return http.get(`${API_URL}project/amount-with-discount/?${serializeParams(payload)}`)
      .then(response => {
        console.log('project/amount-with-discount', serializeParams(payload), response.data);
        logrocket.identify(payload.billCode, {
          ...response.data,
        });

        return response;
      });
  },

  projectPaymentCreate(data) {
    return http.post(`${API_URL}project/payment/create`, data).then(response => {
      console.log('project/payment/create', data.projectId, data);
      logrocket.identify(data.projectId, {
        ...data,
      });

      return response;
    });
  },

  /*
    language - передается строковый код языка
    projectCode - код проекта
    billCode - идентификатор счета
    publicId - идентификатор платежа
  */
  getProjectLocale(params) {
    console.log('HTTP::getProjectLocate', params);
    return http.get(`${API_URL}project/locale?${serializeParams(params)}`);
  },

  /*
   * Отправка кода подтверждения из смс
   *
   * paymentId - идентификатор платежа
   * otp - код подтверждения из смс
   */
  // /v1/pp/card/otp-confirm
  confirmOneTimePassword(data) {
    console.log('HTTP::confirmOneTimePassword', data);
    return http.post(`${API_URL}card/otp-confirm`, data);
  },

  // /v1/pp/deal/?publicId=&processToken=
  getSafeDeal(params) {
    console.log('HTTP::getSafeDeal', params);
    return http.get(`${API_URL}deal/?${serializeParams(params)}`);
  },

  // POST /v1/pp/deal/
  checkClosedDeal(data) {
    console.log('HTTP::checkClosedDeal', data);
    return http.post(`${API_URL}deal/`, data);
  },

  // POST /v1/pp/deal/dispute
  dealDispute(data) {
    console.log('HTTP::dealDispute', data);
    return http.post(`${API_URL}deal/dispute`, data);
  },

  // GET /v1/pp/payment/origin?id=
  getPaymentOrigin(publicId) {
    console.log('HTTP::getPaymentOrigin', publicId);
    return http.get(`${API_URL}payment/origin?id=${publicId}`);
  },

  // GET /v1/pp/crypto/qr-code?hash=
  getCryptoQrCodeByHash(hash) {
    console.log('HTTP::GET::/v1/pp/crypto/qr-code?hash=', hash);
    return http.get(`${API_URL}crypto/qr-code?hash=${hash}`);
  },

  // GET /v1/pp/crypto/transactions?paymentId=9f980b61-8712&projectCode=test.ua
  getCryptoTransactionsByParams(params) {
    console.log('HTTP::getCryptoTransactionsByPaymentId', params);
    return http.get(`${API_URL}crypto/transactions/?${serializeParams(params)}`);
  },
};
